import { combineReducers } from 'redux';

import { accountAssociationModalReducer } from './account-association-modal/account-association-modal.state';
import { updateUserSettingsReducer } from './update-settings/update-settings.state';

import { updateUserSettingsMiddleware } from './update-settings/update-settings.middleware';

export const settingsReducer = combineReducers({
    accountAssociationModal: accountAssociationModalReducer,
    updateUserSettings: updateUserSettingsReducer,
});

export const settingsMiddlewares = [
    updateUserSettingsMiddleware,
];
